import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {take} from 'rxjs/operators';
import {AppComponent} from '../app.component';
import {ActivatedRoute} from '@angular/router';
import {Batiment} from '../Models/Batiment';
import {cloneDeep} from "lodash";
import _ from 'lodash';
import {specialHideTutoHelper} from '../const/utils';
import {ROUTES_PATHS} from "../const/routes";
import {SiteKeyEnum} from "../enums/site-key.enum";

declare var $: any;

@Component({
	selector: 'app-bloc-head-info',
	templateUrl: './bloc-head-info.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./bloc-head-info.component.less']
})
export class BlocHeadInfoComponent implements OnInit {
	textes: any;
	classList: any = "";
	titleBulle: any = "";
	bienCpShort: any = "";
	isInModal: boolean = false;
	isModalImgSpecial: boolean = false;
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	currentPiece: any = null;
	arrSimDetail: any = [];
	prestations: any = [];
	public specialHideTutoHelper = specialHideTutoHelper;

	constructor(
		public app: AppComponent,
		private activatedRoute: ActivatedRoute
	) {
	}

	ngOnInit(): void {
		let currentModal = JSON.parse(localStorage.getItem("modalOpen")!);

		console.log("currentModal ==> ", currentModal);

		this.isInModal = (currentModal) ? true : false;
		//console.log("=============================================this.isInModal",this.isInModal);

		if (currentModal != null) {
			this.isModalImgSpecial = (currentModal.isModalImgSpecial) ? true : false;
			this.app.sharedToolsService.getNameJsonInModal(currentModal.name)
				.then(() => {
					let nameObjInModalJson: any = "";

					this.app.dataToolsService.currentModalNameJson
						.pipe(take(1))
						.subscribe(string => {
							nameObjInModalJson = string;

							this.getInfosInitInModal(nameObjInModalJson);
						})
				})
				.catch(() => {
					console.error('Failed!');
				});
		} else {
			// Load the nameJson and initialize the component
			this.app.dataInitService.getNameJsonReady((nameJson) => {
				this.getInfosInit(nameJson);
			});
		}

		let simulationId = (this.batiment && this.batiment.simulationId) ? parseInt(this.batiment.simulationId) : -1;

		if (simulationId > 0) {
			this.app.apiToolsService.getSimulationParamsById(simulationId).subscribe(res => {
				//console.log("res getSimulationParamsById", res);

				let arrSimDetailTemp: any = cloneDeep(res);
				let arrSimDetail: any = JSON.parse(arrSimDetailTemp);

				if (!arrSimDetail || arrSimDetail.length == 0) return;

				let central = arrSimDetail.filter((pic: any) => {
					return pic.type == -1;
				})[0];
				//console.log("central ==> ", central);

				if (central) {
					for (var i = 0; i < central.arrPrestations.length; i++) {
						if (central.arrPrestations[i].isSelected && central.arrPrestations[i].id != 2 && central.arrPrestations[i].id != 4) {
							central.arrPrestations[i].isSelected = false;
							central.arrPrestations[i].isDisabled = true;
						}
					}
				}

				// Si pas cuisine, déocher aménagement
				let notCuisine = arrSimDetail.filter((pic: any) => {
					return pic.type != 12;
				});
				//console.log("notCuisine ==> ", notCuisine);

				if (notCuisine.length > 0) {
					notCuisine.forEach((pic: any) => {
						// let arrPrestationsOrdered = _.orderBy(pic.arrPrestations, ['id']);
						// console.log("arrPrestationsOrdered ==> ", pic.label, arrPrestationsOrdered);
						// pic.arrPrestations = arrPrestationsOrdered;

						let amenagement = pic.arrPrestations.filter((presta: any) => {
							return presta.id == 6;
						})[0];

						if (amenagement && amenagement.isSelected) amenagement.isSelected = false;
						//console.log("amenagement ==> ", amenagement);
					});
				}

				// Si pas piece d'eau, décocher plomberie
				let notPicEau = arrSimDetail.filter((pic: any) => {
					return pic.type != 12 && pic.type != 36 && pic.type != 28;
				});
				console.log("notPicEau ==> ", notPicEau);

				if (notPicEau.length > 0) {
					notPicEau.forEach((pic: any) => {
						for (var i = 0; i < pic.arrPrestations.length; i++) {
							if (pic.arrPrestations[i].isSelected && pic.arrPrestations[i].id == 3) pic.arrPrestations[i].isSelected = false;
						}
					});
				}

				arrSimDetail.forEach((pic: any) => {
					let arrPrestationsOrdered = _.orderBy(pic.arrPrestations, ['id']);
					//console.log("arrPrestationsOrdered ==> ", pic.label, arrPrestationsOrdered);
					pic.arrPrestations = arrPrestationsOrdered;
				});

				this.arrSimDetail = cloneDeep(arrSimDetail);

				console.log("this.arrSimDetail ==> ", this.arrSimDetail);
				console.log("this.prestations ==> ", this.prestations);
			});
		}
	}

	getSectionTextesPage(_picTypeId: any, _data: any) {
		let section: any;

		switch (_picTypeId) {
			case '-1':
				section = _data.central;
				break;
			case '200':
				section = _data.sejour;
				break;
			case '12':
				section = _data.cuisine;
				break;
			case '17':
				section = _data.entree;
				break;
			case '15':
				section = _data.degagement;
				break;
			case '36':
				section = _data.wc;
				break;
			case '28':
				section = _data.salleDeBain;
				break;
			case '10':
				section = _data.chambre;
				break;
			default:
				section = _data.default;
				break;
		}
		return section;
	}

	getInfosInit(_nameJson: any) {
		// Get class list for h1
		this.app.sharedToolsService.getClassesList()
			.then(() => {
				this.app.dataToolsService.currentClassList.subscribe(string => {
					this.classList = string;
					console.log("this.classList ==> ", this.classList);
				})
			})
			.catch(() => {
				console.error("Error getting classList");
			});

		// Load the texts
		this.app.sharedToolsService.loadTexts(_nameJson)
			.subscribe(textes => {
				let paramPicTypeId = this.activatedRoute.snapshot.params['typeId'];
				console.log("paramPicTypeId ==> ", paramPicTypeId);

				this.textes = (paramPicTypeId) ? this.getSectionTextesPage(paramPicTypeId, textes) : textes;

				setTimeout(() => {
					if (this.textes) this.titleBulle = this.textes.title;

					// ==> On recupere des data siblings or data tools le current bien
					let cpIsPresent = false;

					if (!this.batiment) return;

					let _simId: any = (this.batiment && this.batiment.simulationId) ? parseInt(this.batiment.simulationId) : null;

					//console.log("this.batiment ==> ", this.batiment);
					cpIsPresent = (this.batiment.adress && this.batiment.cp) ? true : false;
					this.bienCpShort = this.batiment.cp.toString().slice(0, 2);

					// ==> On filtre le title selon s'il y a une adresse dans le bien.
					//console.log("this.textes ==> ", this.textes);
					if (this.textes) this.titleBulle = (this.app.router.url == "/" + ROUTES_PATHS.CHOIX_RENOV && cpIsPresent) ? this.textes.titleAutre : this.textes.title;

					if (this.titleBulle) this.titleBulle = this.titleBulle.replace("##DEPARTEMENT##", this.bienCpShort);

					try {
						if (this.titleBulle.indexOf("##TYPE_PROJET##") != -1) this.titleBulle = this.titleBulle.replace("##TYPE_PROJET##", this.batiment.typeRenovationBis.toLowerCase());
						if (this.titleBulle.indexOf("##CODE_POSTAL##") != -1) this.titleBulle = this.titleBulle.replace("##CODE_POSTAL##", this.batiment.cp.toLowerCase());
					} catch (err) {
						console.warn("[err] token in title :" + err.message);
					}

					if (!_simId) return;

					this.app.apiToolsService.getSimulationParamsById(_simId).subscribe(res => {
						//console.log("res getSimulationParamsById", res);

						let arrSimDetailTemp: any = cloneDeep(res);
						let arrSimDetail: any = JSON.parse(arrSimDetailTemp);

						if (!arrSimDetail || arrSimDetail.length == 0) return;

						this.currentPiece = arrSimDetail.filter((pic: any) => {
							return pic.type == paramPicTypeId;
						})[0];
						//console.log("this.currentPiece ==> ", this.currentPiece);

						// ==> Add class text-white to the txt-surligne element
						this.app.sharedToolsService.getClassWitheTextInSurligne();
					});
				}, 1);

			})
	}

	getInfosInitInModal(_nameObjInJsonModal: any) {
		this.app.sharedToolsService.getJSON("txtModals").subscribe(resp => {
			console.log("getInfosInitInModal resp", resp, _nameObjInJsonModal);

			this.textes = resp[_nameObjInJsonModal];
			console.log("getInfosInitInModal this.textes ", this.textes);

			this.titleBulle = (this.app.sharedToolsService.returnObjectSwitchRefId() === SiteKeyEnum.SELOGER && !!this.textes.titleSeLoger)
				? this.textes.titleSeLoger
				: this.textes.title;
			this.classList = this.textes.classTitle;

			// ==> On recupere le titre dynamique selon add or edit
			if (_nameObjInJsonModal == "addUser") {
				let modalData = JSON.parse(localStorage.getItem('modalOpen')!);

				if (modalData) {
					// ==> On recupere l'action (add or edit)
					if (modalData?.data?.id != -1) this.titleBulle = this.textes.titleEdition;

					// ==> On recupere le role
					this.titleBulle = this.titleBulle + ' un(e) ' + this.getTheRoleInTitle(modalData.data.role);
				}
			}
		});
	}

	getTheRoleInTitle(_role: any) {
		let role = "";
		if (_role == 2) role = this.textes.titleRole2;
		if (_role == 3) role = this.textes.titleRole3;

		return role;
	}

	getPaddingLeft(_textes: any) {
		let paddingLeft: any = "";

		let pLeftPlus = (_textes.paddingLeftTxt) ? _textes.paddingLeftTxt : 30;

		if (_textes.imgIntroWidth && !_textes.imgPosLeft) {
			paddingLeft = (_textes.imgIntroWidth + pLeftPlus) + 'px';
		} else if (_textes.imgIntroWidth && _textes.imgPosLeft) {
			let leftNb = this.justNumbers(_textes.imgPosLeft);
			let isNbNegatif: boolean = (_textes.imgPosLeft.indexOf("-") != -1) ? true : false;
			paddingLeft = (_textes.paddingLeftTxt == 0 && isNbNegatif) ? (_textes.imgIntroWidth - leftNb - 30) + 'px' : (_textes.imgIntroWidth - leftNb + pLeftPlus) + 'px';
		} else {
			paddingLeft = '170px';
		}
		return paddingLeft;
	}

	justNumbers(string: any) {
		var numsStr = string.replace(/[^0-9]/g, '');
		return parseInt(numsStr);
	}

	onChangePicSelected() {
		if (!this.currentPiece) return;
		console.log("this.currentPiece ==> ", this.currentPiece);

		let piece = this.arrSimDetail.filter((pic: any) => {
			return pic.id == this.currentPiece.id;
		})[0];

		piece.isSelected = this.currentPiece.isSelected;
		piece.arrPrestations.forEach((presta: any) => {
			presta.isSelected = piece.isSelected;

			if (piece.type != 12) if (presta.id == 6) presta.isSelected = false;
		})

		console.log("piece:", piece);

		let simulationId = (this.batiment.simulationId) ? parseInt(this.batiment.simulationId) : -1;
		let list = [];
		list.push(piece);

		this.app.apiToolsService.setSimulationParamsById(simulationId, list).subscribe(res => {
			console.log("res ==> ", res);

			if (res == 'OK') {
				location.reload();
			}
		});
	}

	onOpenVideoHelp(_urlVideo: string) {
		// Hide all tooltips
		$('[data-toggle=\"tooltip\"]').tooltip('hide');
		window.open(_urlVideo);
	}
}
